import type { ArticleCategory } from "@/types/content";

export const categoryMeta: Record<
  ArticleCategory,
  { label: string; desc: string; icon: string }
> = {
  version: {
    label: "完整版介绍",
    desc: "版本、片长、叙事结构与资料整理",
    icon: "ri-film-line",
  },
  review: {
    label: "影评",
    desc: "表演、镜头与人物心理的深度评论",
    icon: "ri-quill-pen-line",
  },
  behind: {
    label: "拍摄花絮",
    desc: "美术、造型与片场幕后故事",
    icon: "ri-clapperboard-line",
  },
  analysis: {
    label: "剧情解析",
    desc: "逐段拆解剧情脉络与关键细节",
    icon: "ri-book-open-line",
  },
};

export const categoryOrder: ArticleCategory[] = [
  "version",
  "review",
  "behind",
  "analysis",
];

export const sortOptions = [
  { value: "date", label: "按发布时间" },
  { value: "views", label: "按热度" },
];

export const pageSize = 6;